import { ChangeDetectionStrategy, Component, ElementRef, input, inject } from '@angular/core';
import { SkeletonLoaderDirective } from 'projects/login/src/app/utils/skeleton-loader.directive';
import { ThemeService } from 'projects/login/src/app/whitelabel/theme.service';

@Component({
  selector: 'pay-login-logo',
  imports: [SkeletonLoaderDirective],
  templateUrl: './login-logo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginLogoComponent {
  readonly el = inject(ElementRef);

  readonly width = input<number>(60);
  readonly height = input<number>(40);
  logo: string = ThemeService.logo;
}
